import { el, list, setAttr, mount, unmount } from 'redom';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';
import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import application from 'application';
import serverInterface from 'server-interface';

import conversationTypes from 'constants/conversation-types';
import deliveryChannelTypes from 'constants/delivery-channel-types';

import Sender from './sender';

import './index.scss';

class SenderButton {

  constructor(configuration) {

    this.conversation = configuration.conversation;
    this.draftId = configuration.draftId;
    this.onChange = configuration.onChange;

    this.outsideClickRegistration = null;

    this.availableSenders = this.determineSenders();
    this.currentSenderId = this.determineCurrentSender();

    this.senderMenu = null;

    this.senderButton = el('#sender-button', {
      onclick: this.showSenderMenu.bind(this)
    });

    this.showCurrentSender();

    this.el = el('#sender-button-main', [
      this.senderButton
    ]);

  }

  select(sender) {

    if (this.currentSenderId === sender._id) {
      return;
    }

    this.currentSenderId = this.conversation.lastOutboundMessageSenderId = sender._id;

    this.showCurrentSender();
    this.hideSenderMenu();

    serverInterface.startup.helpdesk.setMessageSender(this.conversation._id, this.draftId, this.currentSenderId);

    this.onChange(this.currentSenderId);

  }

  isSelected(sender) {

    return this.currentSenderId === sender._id;

  }

  hideSenderMenu() {

    unmount(this.el, this.senderMenu);

    this.senderMenu = null;
    this.outsideClickRegistration.cancel();

  }

  showSenderMenu() {

    if (this.senderMenu !== null) {
      this.hideSenderMenu();
      return;
    }

    this.senderMenu = list('#message-sender-menu', Sender, '_id', this);

    this.senderMenu.update(this.availableSenders);

    mount(this.el, this.senderMenu);

    this.outsideClickRegistration = new OutsideClickEventRegistration(this.senderMenu.el, this.hideSenderMenu.bind(this));

    const element = this.senderMenu.el;
    const anchorElement = this.senderButton;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 5;
    const startSide = 'top';
    const placeOnCenter = false;
    const positionableSides = ['top'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  showCurrentSender() {

    const currentSender = this.availableSenders.find(sender => sender._id === this.currentSenderId);

    setAttr(this.senderButton, {
      style: {
        'background-image': 'none'
      }
    });
    this.senderButton.textContent = '';
    if (currentSender.profilePicture === void 0) {
      this.senderButton.textContent = currentSender.fullName.charAt(0);
    } else {
      setAttr(this.senderButton, {
        style: {
          'background-image': `url(${currentSender.profilePicture.url})`
        }
      });
    }

  }

  determineSenders() {

    const currentUser = application.getUser();
    const defaultSender = {
      _id: currentUser._id,
      email: currentUser.emailIdentity.fromEmailAddress,
      profilePicture: currentUser.profilePicture,
      fullName: currentUser.fullName
    };
    const senders = [defaultSender];
    const expectedDeliveryChannels = [
      deliveryChannelTypes.APPLICATION,
      deliveryChannelTypes.EMAIL
    ];
    if (expectedDeliveryChannels.includes(this.conversation.deliveryChannel) === true) {

      const divisionIdentities = application.startupModule.getDivisionIdentities().filter((identity) => identity.name !== 'assistant').map(identity => ({
        _id: identity._id,
        email: identity.fromEmailAddress,
        profilePicture: identity.profilePicture,
        fullName: identity.fromName
      }));

      senders.push(...divisionIdentities);

    }

    return senders;

  }

  determineCurrentSender() {

    let currentSenderId = this.conversation.lastOutboundMessageSenderId || this.conversation.initialReceiver._id;

    const currentSender = this.availableSenders.find(sender => sender._id === currentSenderId);

    if (!currentSender) {
      currentSenderId = application.getUser()._id;
    }

    return currentSenderId;

  }

  update(configuration) {

    this.onChange = configuration.onChange;
    this.conversation = configuration.conversation;
    this.draftId = configuration.draftId;

    this.availableSenders = this.determineSenders();
    this.currentSenderId = this.currentSenderId || this.determineCurrentSender();

    this.showCurrentSender();

  }

}

export default SenderButton;